<template>
<div class='orderRead max-width'>

	<!-- 左侧导航栏 -->
	<!-- <div class='orr_menu'>
		<template v-for='(item,index) in orr_menu'>
			<div :key='item.id' class='orr_menu_model'>
				<div class='orr_menu_mod_title font-16 color-body fontweight-bo'>{{item.title}}</div>
				<template v-for='(obj,seq) in item.data'>
					<div :key='obj.id' 
						 :class="{'orr_menu_mod_line font-14 bg-hoer-shallow':true, 'bgcolor-shallow':obj.choose, 'color-prompt-deep':!obj.choose}" 
						 :data-index='index' 
						 :data-seq='seq' 
						 @click='func_menu' 
						 >{{obj.name}}
					</div>
				</template>
			</div>
		</template>
	</div> -->
	<v-afficheSidebar></v-afficheSidebar>


	<!-- 右侧主体内容 -->
	<div class='orr_model'>
		<div class="news_con_box" id="news_content">

         <!--  编辑器里面内容  -->
            <span style="font-size:14px;color:#000000;">特别提醒：</span><br>
<span style="font-size:14px;">请您在使用彩航印刷网站 ( 以下简称“本网站” ) 前仔细阅读以下条款。若不接受以下条款请勿使用本网站；使用本网站则表明您已明知 并接受如下条款；若违反以下条款，您使用本网站的授权将自动终止。</span><br>
<br>
<span style="font-size:14px;color:#000000;"><strong>前言</strong></span><br>
<span style="font-size:14px;">本 网站由彩航印刷及其授权代理人运行，与本网站相关的一切权利均归属彩航印刷。在使用本网站前，请仔细阅读本声明，您 对本网站的使用(包括但不限于对本网站的访问、登录，对本网站内容的浏览和使用)，将被视为您自愿承诺并接受本声明的约束。如果您对本声明的内容不能同 意，您应当停止使用本网站。</span><br>
<br>
<span style="font-size:14px;color:#000000;"><strong>1．免责事项</strong></span><br>
<span style="font-size:14px;">彩航印刷及其代理人将尽力维护本网站的安全和功能，但不保证一定能满足用户的所有要求，不保证本网站上所有功能永远正常运作，不保证本网站系统适合您电脑的 操作系统或硬件，也不保证网站或其服务器永不产生故障，不被动传播病毒或木马程序及其他有害程序。此外，本网站上所有内容(包括由第三人提供的信息)仅为 消费者参考而提供，彩航印刷不对此做任何关于准确性、及时性及完整性的保证和承诺。彩航印刷对于由于使用本网站或本网站上登载的信息而引起的一切损失，不 承担任何责任。</span><br>
<br>
<span style="font-size:14px;color:#000000;"><strong>2．知识产权</strong></span><br>
<span style="font-size:14px;">本 网站上所有内容，包括但不限于文字、软件、影像、声音、动画、图形、图表、美术设计、照片、图片、名称、标识、商标、服务标志等，均受到相关法律的保护。 本网站的所有内容和信息及其知识产权均归属于彩航印刷，或彩航印刷得到相关权利人之许可而使用。未经彩航印刷和相关权利人的许可，禁止对本网站上任何内容 进行任何方式的下载、复制、传播，篡改或类似于上述方法的其它任何侵害彩航印刷知识产权的行为。</span><br>
<br>
<span style="font-size:14px;color:#000000;"><strong>3．产品信息</strong></span><br>
<span style="font-size:14px;">关于在本网站中所展示的产品，其外形及功能均以实物及正式销售的商品说明书为准，网站页面所提供产品信息仅供参考，不构成对相关产品的任何承诺和保证。</span><br>
<br>
<span style="font-size:14px;color:#000000;"><strong>4．网页链接</strong></span><br>
<span style="font-size:14px;">任 何对本网站设定链接的行为都应该事先获得彩航印刷的同意。但无论是否获得彩航印刷的同意，该等链接都不表明彩航印刷对其网站内容的认可和监控。彩航印刷对 于与本站链接的其他网站内容的合法性、准确性、可靠性以及内容的使用后果及其他的相关事项不做任何担保、承诺和赔偿及其他任何法律责任，同时本网站的使用 条件、个人信息保护条款和程序均不适用于该等链接网站。</span><br>
<br>
<span style="font-size:14px;color:#000000;"><strong>5．个人信息的保护</strong></span><br>
<span style="font-size:14px;">彩航印刷注重保护彩航印刷网站浏览者的隐私和安全，当您访问本网站的时候可能被要求提供您个人的基本资料(如姓名、电子邮件、电话号码等)，您可以自行选择 是否提供。对于您提供的个人信息，我们将根据中华人民共和国相关法律进行保密并严格保管，我们不会违反规定将这些信息转售或转租给任何第三方，但下述情况 除外：</span><br>
<span style="font-size:14px;">(一) 当司法机关或行政机关依照法定程序和法定职权要求本网站披露个人资料时，我们将依法提供相关资料。对于此情况下的任何披露，本网站均得免责；</span><br>
<span style="font-size:14px;">(二) 对于任何由黑客攻击、计算机病毒侵入或发作、或政府管制而造成的暂时性关闭等影响网站正常运营的不可抗力事件所造成的个人资料的泄露、丢失、被盗用或被篡改等，本网站均得免责；</span><br>
<span style="font-size:14px;">(三) 对于用户将个人密码告知他人或与他人共享注册帐号所导致的任何个人资料泄露，丢失、被盗用或被篡改等,本网站不负任何责任；</span><br>
<span style="font-size:14px;">(四) 对于与本网站链接的任何其它网站的个人资料泄露，丢失、被盗用或被篡改等事件，本网站不负任何责任。</span><br>
<br>
<span style="font-size:14px;color:#000000;"><strong>6．网站维护</strong></span><br>
<span style="font-size:14px;">彩航印刷无须事先通知，有权在任何时候对本网站内容以及技术进行更新和维护。您同意因彩航印刷随时对网站维护和变更而导致您无法登陆等情况的出现。但本条不表明彩航印刷负有必须对本网站进行及时更新的义务。</span><br>
<br>
<span style="font-size:14px;color:#000000;"><strong>7．版权投诉</strong></span><br>
<span style="font-size:14px;">彩航印刷尊重他人之知识产权。如果您认为您的作品未经许可以某种方式被本网站所使用，请立即与彩航印刷联络。</span><br>
<br>
<span style="font-size:14px;color:#000000;"><strong>8．网站解释权</strong></span><br>
<span style="font-size:14px;">本网站内容及本声明的修改权、最终解释权均属彩航印刷所有。</span><br>
            <!--  编辑器里面内容  end -->

        </div>
	</div>

</div>
</template>
<script>
export default {
	name: 'orderRead',
	props: {},
	data() {
		return {
			orr_list: [
			
			]
		}
	},
	methods: {
		func_menu(event) {
			const index = event.currentTarget.dataset.index;
			const seq = event.currentTarget.dataset.seq;
			if (!this.orr_menu[index]['data'][seq]['choose']) {
				for (let i in this.orr_menu[index]['data']) {
					if (this.orr_menu[index]['data'][i]['choose']) {
						this.orr_menu[index]['data'][i]['choose'] = false;
						this.orr_menu[index]['data'][seq]['choose'] = true;
						break;
					}
				}
			}
		}
	}
}
</script>
<style src='@/style/orderRead.css'></style>



// WEBPACK FOOTER //
// src/pages/Agreement.vue